import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import "./password.css";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import Footer from "../../components/footer";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import PasswordField from "../../components/input/passwordField";
import InputField from "../../components/input/inputField";
import { useDispatch } from "react-redux"; // Import the dispatch hook
import {
  updateAttorneyData,
  updateStatus,
} from "../../redux/attorneyDataSlice";
import { authenticatedFetch } from "../../network/api";

const Password = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch(); // Initialize the dispatch function

  // Extract the initial email from route state (fallback to empty string if not found)
  const { email: initialEmail = "" } = location.state || {};

  const [password, setPassword] = useState("");
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [emailValue, setEmailValue] = useState(initialEmail);
  const [alert, setAlert] = useState(null);
  const [error, setError] = useState(""); // To show any error messages

  // Toggle edit mode for email
  const handleEditEmail = () => {
    setIsEditingEmail(true);
  };

  // Submit logic: sign in, then verify role by calling our serverless API

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure email and password are provided
    if (!emailValue.trim() || !password.trim()) {
      return;
    }

    try {
      // Step 1: Authenticate the user with Supabase
      const { data, error } = await supabase.auth.signInWithPassword({
        email: emailValue, // make sure this is correctly named
        password: password, // the correct variable for password
      });

      if (error) {
        setError(error.message || "Authentication failed");
        return;
      }

      // Step 2: Send the access token (JWT) to the backend to verify the account type
      const accessToken = data.session.access_token;

      const response = await authenticatedFetch("/api/attorney/webapp/attorneySignIn", {
        method: "POST",
        body: JSON.stringify({ email: emailValue }),
      });

      const responseData = await response.json();

      if (response.ok) {
        // Manually update the client data in Redux
        // Assuming the data returned from API contains the client data
        dispatch(updateAttorneyData(responseData.attorneyDetails)); // Here you would send the client data
        dispatch(updateStatus("succeeded")); // Status aligned with data-loaded state
        // const errorData = await roleResponse.json();
        navigate(`/attorney/${responseData.attorneyDetails.user_id}/home`, {
          state: data,
        });
      } else {
        setError(responseData.message || "Failed to verify account type");
        setAlert({
          severity: "error",
          message: "Unauthorized access.",
        });
        // Sign out the user if unauthorized
        await supabase.auth.signOut();
        return;
      }
    } catch (error) {
      setError("An error occurred during login.");
      console.error("Error during sign-in:", error);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SignupToolbar />
      {alert && (
        <Alert
          severity={alert.severity}
          style={{
            marginTop: "100px",
            marginLeft: "30px",
            marginRight: "30px",
          }}
        >
          {alert.message}
        </Alert>
      )}
      <div className="password-container">
        <div className="password-form-wrapper">
          <h2 className="password-heading">Enter your password</h2>

          <div className="password-email-row">
            {/* If not editing, show plain text & Edit button */}
            {!isEditingEmail && (
              <>
                <span className="password-email">{emailValue}</span>
                <button
                  type="button"
                  className="password-edit-button"
                  onClick={handleEditEmail}
                >
                  Edit
                </button>
              </>
            )}

            {/* If editing, show the InputField (no Edit button) */}
            {isEditingEmail && (
              <InputField
                name="email"
                title="Email"
                placeholder="Enter email address"
                isRequired={true}
                value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
            )}
          </div>

          <PasswordField
            title="Password"
            placeholder="Enter your password"
            isRequired={true}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            type="submit"
            className="password-button"
            onClick={handleSubmit}
          >
            Continue
          </button>

          <div className="password-forgot-container">
            <a href="/grow/reset-password" className="password-forgot-link">
              Forgot your password?
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Password;
